<template>
  <div class="page page-Home" :class="{ loaded: isLoaded }">
    <div class="pictures m25" :style="bgImgStyle(backgroundImages)"></div>

    <div class="content">
      <div class="m50">
        <h1 class="m50">стань частью команды</h1>

        <div class="btns" v-if="!isMobile">
          <a href="https://hh.ru/employer/3233751" class="btn" target="_blank">погнали</a>
          <!--<router-link :to="{ name: 'Vacancies'}" class="btn">погнали</router-link>-->
        </div>
      </div>
    </div>

    <div class="btns" v-if="isMobile">
      <a href="https://hh.ru/employer/3233751" class="btn" target="_blank">погнали</a>
      <!--<router-link :to="{ name: 'Vacancies'}" class="btn">погнали</router-link>-->
    </div>
  </div>
</template>

<style lang="less">
@import "../assets/css/select2.less";
</style>

<script>
import { loader } from '../mixins/loader';
import { isMobile } from '../mixins/isMobile';
import { functions } from '../mixins/functions';

export default {
  name: 'Home',
  mixins: [loader, isMobile, functions],

  data() {
    return {
      pageData: { page: 'Home' },
      backgroundImages: {}
    };
  },

  deactivated() {
    this.isLoaded = false;
  },

  activated() {
    var _t = this;

    if (_t.$store.state.pagesLoaded.App && _t.$store.state.pagesLoaded.Home) {
      _t.onActivated();
    } else {
      _t.$store.commit('loaderON');

      _t.$store.subscribe((mutation, state) => {
        if (mutation.type === 'pageLoaded' && mutation.payload.page === 'Home') {
          _t.onActivated();
        }
      });
    }
  },

  created() {
    this.$store.dispatch('loadData', {
      page: 'Home'
    });
  },

  methods: {
    onActivated() {
      var _t = this;
      _t.backgroundImages = _t._('backgroundImages');

      if (_t.imagesLoaded) {
        _t.pageLoaded();
      } else {
        _t.loadImages(_t.backgroundImages);
      }
    },
    changeCity(val) {
      if (val.target) {
        val = { id: val.target.value };
      }
      this.$store.commit('changeCity', { val: val });
    },
    changeDepartment(val) {
      if (val.target) {
        val = { id: val.target.value };
      }
      this.$store.commit('changeDepartment', { val: val });
    }
  }
};
</script>
